import React from 'react';
import Form from 'antd/lib/form';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputCode = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", null,
        "3-letter code ",
        React.createElement(Tooltip, { title: 'e.g. "OMQ" for Open Men Qualifier. This will be combined a bib number to create a ID for your athlete (e.g. OMQ001)' },
            React.createElement(Icon, { className: formStyles.labelTooltipIcon, type: 'question-circle-o' }))), colon: false }, props.form.getFieldDecorator('code', {
    initialValue: props.initialValue || '',
    rules: [{
            required: true,
            message: 'Please set a code',
        }, {
            len: 3,
            message: 'Code must be 3 letters',
        }, {
            pattern: /^[A-Z]{3}$/,
            message: 'Only alphabets are allowed',
        }, {
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Input, { size: 'large', autoComplete: 'off', disabled: props.isDisabled, onChange: function (e) {
        e.target.value = e.target.value.substring(0, 3).toUpperCase();
    } })))); };
export default InputCode;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/FormRound/InputCode.tsx
// module id = 1186
// module chunks = 0